module.exports = __webpack_public_path__ + "img/bike_caloi.8285832c.jpg";